import { DefaultPageType } from '../../../api/custom-pages.dao';
import {
    CALENDAR_BUTTON_ENABLED,
    DEFAULT_CAROUSEL_VIEW,
    defaultPagesConfig as config,
    EMBED_CODE_ID,
    GENERAL_SESSIONS_NOTES,
    HOST_ATTENDEES_ENABLED,
    LABEL,
    LAYOUT,
    LINK_DESCRIPTION,
    MY_SCHEDULE_NOTES,
    PAST_SESSIONS_ENABLED,
    PRE_REGISTRATION_ENABLED,
    REPLAYS_DEFAULT_CAROUSEL_VIEW,
    REPLAYS_LAYOUT,
    REPLAYS_NOTES,
    REPLAYS_PRE_REGISTRATION_ENABLED,
    REPLAYS_SESSION_LABEL,
    REGISTER_BUTTON_LABEL,
    RESTRICT_ACCESS_ENABLED,
    RESTRICT_ACCESS_FILTERS,
    SORT_ORGANIZATION_BY,
    SUPPORT_INFORMATION,
    TOPIC_ENABLED,
    UPCOMING_SESSIONS_ENABLED,
    UPCOMING_SESSIONS_LABEL,
    UPCOMING_SESSIONS_TYPE,
    WELCOME_KNOVIO_EMBED_ID,
    WELCOME_KNOVIO_ENABLED,
    SUBSCRIBE_ATTENDEE_TO_MEETING_ON_REGISTRATION_ENABLED
} from '../config';
import { FormVmItemConfigType } from '../../../infrastructure/form-viewmodel-controller';


export class DefaultPageEntityConfig {
    public static getVmConfigByType(type: DefaultPageType): FormVmItemConfigType[] {
        return this.getPageKeysByType(type).map(key => ({ name: key, ...config[key] }));
    }

    public static getPageTypes(): DefaultPageType[] {
        return Object.keys(this.keysPerType) as DefaultPageType[];
    }

    private static getPageKeysByType(type: DefaultPageType): string[] {
        return this.keysPerType[type] ?? [];
    }

    private static get keysPerType(): Record<DefaultPageType, string[]> {
        return {
            [DefaultPageType.Agenda]: [ LABEL, LINK_DESCRIPTION, TOPIC_ENABLED, MY_SCHEDULE_NOTES, RESTRICT_ACCESS_ENABLED, RESTRICT_ACCESS_FILTERS ],
            [DefaultPageType.Session]: [
                LABEL,
                LINK_DESCRIPTION,
                LAYOUT,
                DEFAULT_CAROUSEL_VIEW,
                RESTRICT_ACCESS_ENABLED,
                RESTRICT_ACCESS_FILTERS,
                PRE_REGISTRATION_ENABLED,
                HOST_ATTENDEES_ENABLED,
                GENERAL_SESSIONS_NOTES,
                REGISTER_BUTTON_LABEL,
                PAST_SESSIONS_ENABLED,
                SUBSCRIBE_ATTENDEE_TO_MEETING_ON_REGISTRATION_ENABLED
            ],
            [DefaultPageType.Support]: [ LABEL, LINK_DESCRIPTION, SUPPORT_INFORMATION ],
            [DefaultPageType.Welcome]: [ LABEL, LINK_DESCRIPTION, WELCOME_KNOVIO_ENABLED, WELCOME_KNOVIO_EMBED_ID, CALENDAR_BUTTON_ENABLED ],
            [DefaultPageType.Showcase]: [ LABEL, LINK_DESCRIPTION, EMBED_CODE_ID ],
            [DefaultPageType.Speakers]: [ LABEL, LINK_DESCRIPTION, SORT_ORGANIZATION_BY ],
            [DefaultPageType.Replays]: [
                LABEL,
                LINK_DESCRIPTION,
                UPCOMING_SESSIONS_ENABLED,
                HOST_ATTENDEES_ENABLED,
                UPCOMING_SESSIONS_TYPE,
                UPCOMING_SESSIONS_LABEL,
                REPLAYS_SESSION_LABEL,
                REPLAYS_PRE_REGISTRATION_ENABLED,
                REPLAYS_NOTES,
                REPLAYS_LAYOUT,
                REPLAYS_DEFAULT_CAROUSEL_VIEW,
                RESTRICT_ACCESS_ENABLED,
                RESTRICT_ACCESS_FILTERS
            ]
        };
    }
}